import type { InsurerStats } from 'BrokerTsLib/src/dtos'

// Constants
export const MAX_COMPANIES_FOR_GROUPING = 4 // Only group if 4+ companies

// Chart data type
export interface ChartDataItem {
  name: string | undefined
  value: number
  count: number
  price: number
  insurerId: number
  fill: string
  isOthers?: boolean
  companies?: ChartDataItem[]
}

// Sorting functions
export const sortCompaniesByCount = (a: InsurerStats, b: InsurerStats) => b.count - a.count
export const sortCompaniesByTotalValue = (a: InsurerStats, b: InsurerStats) => b.price - a.price
